import {Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ScheduleSerieService } from '../services/scheduleserie.service';
import { ScheduleSerie } from '../models/scheduleserie';
import { CustomerService } from '../services/customers.service';
import { Customer } from '../models/customer';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-reportscm',
  templateUrl: './reportscm.component.html',
  providers: [ScheduleSerieService, CustomerService]
})
export class ReportscmComponent implements OnInit {
  public customer: Customer;
  public customerSelected: Customer;
  public stardDateSelected: Date;
  public endDateSelected: Date;
  public dropdownCustomer: SelectItem[];
  public listCustomers: Customer[] = [];
  public listScheduleSeries: ScheduleSerie[];
  cols: any[];
  first = 0;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private scheduleSerieService: ScheduleSerieService,
    private customerService: CustomerService
  ) {
    this.cols = [
      {field: 'scheduleId', header: 'Agenda Id'},
      {field: 'schedule', header: 'Agenda'},
      {field: 'nit', header: 'NIT'},
      {field: 'datePurchase', header: 'Fecha Com.'},
      {field: 'mark', header: 'Marca'},
      {field: 'model', header: 'Modelo'},
      {field: 'colour', header: 'Color'},
      {field: 'imei', header: 'Imei'},
      {field: 'cover', header: 'Tapa'},
      {field: 'battery', header: 'Bateria'},
      {field: 'loader', header: 'Cargador'},
      {field: 'memoryRemovable', header: 'Memoria Ex.'},
      {field: 'freeHand', header: 'Manos Libres'},
      {field: 'other', header: 'Otros'},
      {field: 'failure', header: 'Falla'},
    ];
    this.customerSelected = new Customer();
    this.stardDateSelected = new Date();
    this.endDateSelected = new Date();
  }

  ngOnInit() {
    this.getCustomer();
    this.getSchedules();
  }

  getCustomer(){
    this.customerService.getActive(true).subscribe(
      response => {
        if (response.statusCode === '200 OK') {
          this.customer  = response.object;
          this.listCustomers = response.object;
          this.generateDropdownCustomer();
        } else {
          console.log(response);
        }
      },
      error => {
        console.log(<any> error);
      }
    );
  }
  generateDropdownCustomer(){
    this.dropdownCustomer = [];
    this.dropdownCustomer.push({ label: 'Seleccione', value: null });
    for (const hq of this.listCustomers) {
      this.dropdownCustomer.push({ label: hq.name, value: hq });
    }
  }
  getSchedules() {
    this.listScheduleSeries = [];
    this.scheduleSerieService.get().subscribe(
      response => {
        if (response.statusCode === '200 OK') {
          this.listScheduleSeries = response.object;
          if (this.listScheduleSeries.length > 0) {
            this.listScheduleSeries.forEach(sch => {
              sch.datePurchase1 = this.formatDatesRepots(String(sch.datePurchase));
            });
          }
        } else {
          console.log(response);
          alert('No se Encuentran Registros');
        }
      },
      error => {
        console.log( error as any);
        alert('Error en la Consulta');
      }
    );
  }
  getSchedulesFilters() {
    this.listScheduleSeries = [];
    let fini:any;
    let ffin:any;
    if(this.stardDateSelected != null && this.endDateSelected != null)
    {
      let date = ("0" + this.stardDateSelected.getDate()).slice(-2);
      let month = ("0" + (this.stardDateSelected.getMonth() + 1)).slice(-2);
      let year = this.stardDateSelected.getFullYear();
      fini = year + "-" + month + "-" + date;
      let datef = ("0" + this.endDateSelected.getDate()).slice(-2);
      let monthf = ("0" + (this.endDateSelected.getMonth() + 1)).slice(-2);
      let yearf = this.endDateSelected.getFullYear();
      ffin = yearf + "-" + monthf + "-" + datef;
    }
    if(this.customerSelected.name!=undefined && this.stardDateSelected === null && this.endDateSelected === null)
    {
      this.scheduleSerieService.getByCustomerId(this.customerSelected.id).subscribe(
        response => {
          if (response.statusCode === '200 OK') {
            this.listScheduleSeries = response.object;
            if (this.listScheduleSeries.length > 0) {
              this.listScheduleSeries.forEach(sch => {
                sch.datePurchase1 = this.formatDatesRepots(String(sch.datePurchase));
              });
            }
          } else {
            console.log(response);
            alert('No se Encuentran Registros');
          }
        },
        error => {
          console.log( error as any);
          alert('Error en la Consulta');
        }
      );
    }else{
      this.scheduleSerieService.getByDate(fini, ffin).subscribe(
        response => {
          if (response.statusCode === '200 OK') {
            this.listScheduleSeries = response.object;
            if (this.listScheduleSeries.length > 0) {
              this.listScheduleSeries.forEach(sch => {
                sch.datePurchase1 = this.formatDatesRepots(String(sch.datePurchase));
              });
            }
          } else {
            console.log(response);
            alert('No se Encuentran Registros');
          }
        },
        error => {
          console.log( error as any);
          alert('Error en la Consulta');
        }
      );
    }
  }
  formatDatesRepots(date: string): string {
    const currentDate: any[] = date.replace('T00:00:00', '').split('-');
    date = currentDate[2] + '/' + currentDate[1] + '/' + currentDate[0];
    return date;
  }

  getDates(date: Date): string {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    if (month < 10 && day < 10) {
      const currentDate = year + '0' + month + '0' + day;
      return currentDate;
    } else if (month >= 10 && day < 10) {
      const currentDate = year + '' + month + '0' + day;
      return currentDate;
    } else if (month < 10 && day >= 10) {
      const currentDate = year + '0' + month + '' + day;
      return currentDate;
    } else if (month >= 10 && day >= 10) {
      const currentDate = year + '' + month + '' + day;
      return currentDate;
    }
  }
  reset() {
    this.first = 0;
  }
}
